goog.provide("shadow.js.shim.module$src$svg$inform$info_circle_svg$default");
shadow.js.shim.module$src$svg$inform$info_circle_svg$default = shadow.js.shim.module$src$svg$inform$info_circle_svg.default;
